// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qq-1";
export var stateContainer = "_qq-0";